import { render } from "./SelectLanguageComponent.vue?vue&type=template&id=4234903b"
import script from "./SelectLanguageComponent.vue?vue&type=script&lang=js"
export * from "./SelectLanguageComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__